import { render } from "./file.vue?vue&type=template&id=e61cd156"
import script from "./file.vue?vue&type=script&lang=js"
export * from "./file.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/input-only/file.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e61cd156"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e61cd156', __exports__)) {
    console.log('reload')
    api.reload('e61cd156', __exports__)
  }
  
  module.hot.accept("./file.vue?vue&type=template&id=e61cd156", () => {
    console.log('re-render')
    api.rerender('e61cd156', render)
  })

}


export default __exports__